module.exports = __webpack_public_path__ + "static/value-for-money-d2f7c726aeae60e370bc494dd91ef195.jpg";